package mundhahs.julian.Material

class FreierParameter(index: Int) : Ergebnis(index) {
    override fun getResult(): String {
        return "${getName()}=${getName()}"
    }
}
